import ApsModels from "../../models";
import fetcher from "./Fetcher";

class SystemService {
  systemNotification = async () => {
    const url = "/api/System/SystemNotification";
    return fetcher.get<ApsModels.ISystemNotificationModels>(url);
  };
}

const systemService = new SystemService();
export default systemService;
